module.exports = __webpack_public_path__ + "img/loginIcon863.f75fd672.png";